/* eslint-disable arrow-body-style */
import React from 'react';
import { useLinkAnalysisResultsStore } from '../../mothership/linkAnalysisResults.state';
import { linkAnalysisId } from '../../types';

export const QeGraphJson = () => {
  const json = useLinkAnalysisResultsStore((state) => state.graphDataQeJson);
  const id = `${linkAnalysisId}QeGraphJson`;
  return (
    <div id={id} data-cy={id} style={{ display: 'none' }}>
      {json}
    </div>
  );
};
